module.exports = __webpack_public_path__ + "img/stock2.7901f21b.png";